import { Button, Flex, Heading, NativeSelect } from "@chakra-ui/react";
import { Link } from "react-router-dom";
import { User } from "firebase/auth";
import { Lang } from "../hooks/lang";

type HeaderProps = {
  user: User | null;
};

export const Header = ({ user }: HeaderProps) => {
  const { t, lang, changeLang } = Lang();
  const handleLang = (e: React.ChangeEvent<HTMLSelectElement>) => {
    changeLang(e.target.value);
  };

  return (
    <Heading>
      <Flex justifyContent={"space-between"} margin={"1rem"}>
        <Flex>
          <Link to="/">Pokédex</Link>
        </Flex>
        <Flex direction={"row"} align={"center"}>
          <NativeSelect.Root size={"lg"}>
            <NativeSelect.Field onChange={handleLang}>
              <option value={"jp"}>jp</option>
              <option value={"en"}>en</option>
            </NativeSelect.Field>
          </NativeSelect.Root>
        </Flex>
      </Flex>
    </Heading>
  );
};
